// Motifs de refus proposés à l'équipe (clés alignées sur
// AbstractOrder::REFUSAL_REASONS côté back, qui valide). 'delai-depasse' est
// réservé au refus automatique (événement passé) et n'est donc pas proposé ici.
export const REFUSAL_REASONS = [
  { key: 'prix', label: 'Prix' },
  { key: 'changement-lieu', label: 'Changement de lieu' },
  { key: 'annulation-evenement', label: 'Annulation événement' },
  { key: 'autre-traiteur', label: 'Choix autre traiteur' },
  { key: 'autre', label: 'Autre' },
];
